export const cohortBuilderInfoBarMessagesEn = {
  'projects.cohortBuilderPage.components.cohortInfoBar.dataset': 'Data set',
  'projects.cohortBuilderPage.components.cohortInfoBar.labelOwner': 'Owner',
  'projects.cohortBuilderPage.components.cohortInfoBar.unknownOwner': 'Unknown',
  'projects.cohortBuilderPage.components.cohortInfoBar.subjects': 'Subjects',
};
